import { redirect } from '@tanstack/react-router'
import { User } from 'oidc-client-ts'

/**
 * Asserts that the user is defined and also that `user.profile.role` is equal to `'Administrator'`.
 * @param user that should be checked.
 * @throws An `Error` when the passed `user` isn't defined or the role isn' equal to `'Administrator'`
 */
export function assertUserIsAdminOrRedirect(
    user: User | null | undefined
): asserts user {
    if (user && user.profile.role !== 'Administrator') {
        // eslint-disable-next-line @typescript-eslint/only-throw-error
        throw redirect({ to: '/', replace: true })
    }
}
